<template>
    <div class="contact-form" ref="targetSection">
        <div v-if="show" class="alert" :class="alertClasses" role="alert" v-html="message">


        </div>
        <h3>Detaylı bilgi için formu doldurun, sizi arayalım!</h3>
        <form @submit.prevent="submitForm" id="partnerForm" action="https://admin.kobisi.com/home/createPartner"
            method="POST">
            <div class="form-row">
                <input type="text" v-model="form.firstName" :class="{ error: errors.firstName }" placeholder="Ad"
                    name="firstname" />
                <input type="text" v-model="form.lastName" :class="{ error: errors.lastName }" placeholder="Soyad"
                    name="lastname" />
            </div>

            <div class="form-row">
                <input type="email" v-model="form.email" :class="{ error: errors.email }" placeholder="E-Posta"
                    name="email" />
                <div class="phone-combined" :class="{ error: errors.phone }">
                    <select v-model="form.countryCode">
                        <option v-for="country in countries" :key="country.code" :value="country.dialCode">
                            {{ country.flag }} {{ country.name }} ({{ country.dialCode }})
                        </option>
                    </select>
                    <input type="tel" v-model="form.phone" :placeholder="''" name="phone" />
                </div>
            </div>

            <div class="form-row">
                <input type="text" v-model="form.city" :class="{ error: errors.city }" placeholder="Şehir"
                    name="city" />
                <input type="text" v-model="form.company" :class="{ error: errors.company }" placeholder="Şirket ismi"
                    name="company_name" />
            </div>

            <div class="form-row">
                <input type="text" v-model="form.website" :class="{ error: errors.website }" placeholder="Websiteniz"
                    name="website" />
                <input type="text" v-model="form.note" placeholder="Not" name="note" />
            </div>

            <div class="checkbox">
                <input type="checkbox" v-model="form.agreement" id="agreement"/>
                <label for="agreement" id="agreement-label">
                    <a href="/cms/kullanim-kosullari" target="_blank">Kullanım sözleşmesi</a>'ni okudum
                    onaylıyorum.
                </label>
            </div>

            <button type="submit">Gönder</button>
        </form>
    </div>
</template>

<script>

//import axios from 'axios';

export default {
    data() {
        return {
            form: {
                firstName: '',
                lastName: '',
                email: '',
                countryCode: '+90',
                phone: '',
                city: '',
                company: '',
                website: '',
                note: '',
                agreement: false
            },
            show: false,
            alertClasses: 'alert alert-success',
            message: '',
            errors: {},
            countries: [
                { name: 'Türkiye', dialCode: '+90', code: 'TR', flag: '🇹🇷' },
                { name: 'Almanya', dialCode: '+49', code: 'DE', flag: '🇩🇪' },
                { name: 'Fransa', dialCode: '+33', code: 'FR', flag: '🇫🇷' },
                { name: 'ABD', dialCode: '+1', code: 'US', flag: '🇺🇸' },
                { name: 'İngiltere', dialCode: '+44', code: 'GB', flag: '🇬🇧' },
                { name: 'Japonya', dialCode: '+81', code: 'JP', flag: '🇯🇵' },
                { name: 'Hindistan', dialCode: '+91', code: 'IN', flag: '🇮🇳' },
                { name: 'Kanada', dialCode: '+1', code: 'CA', flag: '🇨🇦' },
                { name: 'İspanya', dialCode: '+34', code: 'ES', flag: '🇪🇸' },
                { name: 'İtalya', dialCode: '+39', code: 'IT', flag: '🇮🇹' },
            ]
        };
    },
    methods: {
        async submitForm() {
            this.errors = {};
            this.isLoading = true;
            this.submitSuccess = false;

            // Validasyon
            if (!this.form.firstName) this.errors.firstName = true;
            if (!this.form.lastName) this.errors.lastName = true;
            if (!this.form.email) this.errors.email = true;
            if (!this.form.phone) this.errors.phone = true;
            if (!this.form.city) this.errors.city = true;
            if (!this.form.agreement){
                document.getElementById('agreement-label').style.color = 'red';
                return;
            } 

            if (Object.keys(this.errors).length > 0) {
                this.isLoading = false;
                return;
            }

            document.getElementById('partnerForm').submit();
        },
        resetForm() {
            this.form = {
                firstName: '',
                lastName: '',
                email: '',
                countryCode: '+90',
                phone: '',
                city: '',
                company: '',
                website: '',
                note: '',
                agreement: false
            };
        },
        scrollToBottom() {
        
            setTimeout(() => {
                window.scrollTo({
                    top: document.documentElement.scrollHeight - 1200,
                    behavior: 'smooth'
                });
            }, 50); // 50ms gecikme
        },
    },
    beforeMount() {
        if (this.$route.query.success) {
            this.scrollToBottom();
            this.show = true;
            this.alertClasses = 'alert alert-success';
            this.message = 'Başvurunuz alınmıştır. En kısa sürede sizinle iletişime geçilecektir.';

        }

        if (this.$route.query.error) {
            this.scrollToBottom();
            this.show = true;
            this.alertClasses = 'alert alert-danger';

            if (this.$route.query.error === 'already-form') {
                this.message = 'Yakın zamanda kayıt yaptırdınız. Lütfen daha sonra tekrar deneyin.<br>  Eğer bu bir hata ise, <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
            } else if (this.$route.query.error === 'already-register') {
                this.message = 'Bu bilgiler zaten kayıtlı. <br> Eğer bu bir hata ise,  <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
            } else if (this.$route.query.error === 'not-register') {
                this.message = 'Kayıt olurken bir hata oluştu. Lütfen tekrar deneyin yada, <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
            } else {
                this.message = 'Bir hata oluştu. Lütfen tekrar deneyin.';
            }
        }
    },
};
</script>

<style src="./partnerForm.scss" lang="scss" scoped></style>